<ng-container *ngIf="undefined != type">
    {{graphName}}
    <canvas baseChart
        [legend]="legend"
        [data]="data"
        [type]="typeAsEnum!">
    </canvas>
</ng-container>
